export const aboutData = {
  title: "About Me",
  description1: "",
  description2:
    "I am currently pursuing my Master's degree in Computer Software Engineering at San Jose State University. My passion for programming drives me to explore various techniques for solving real-world challenges. I possess a deep interest in application development and am a certfied MERN Stack Developer. Additionally, I am a Machine Learning Enthusiast working at the intersection of Deep Learning and Cyber Physical Systems.",
};
